import { createAction, props } from '@ngrx/store';
import { PaymentCard } from '@shared/models/payment-card';

export const PaymentActions = {
  loadPaymentCards: createAction('[Payment] load cards'),
  loadPaymentCardsFailed: createAction('[Payment] load failed', props<{ error: unknown }>()),
  loadPaymentCardsSuccess: createAction('[Payment] load success', props<{ cards: PaymentCard[] }>()),

  removePaymentCards: createAction('[Payment] remove cards', props<{ cardId: string }>()),
};
